module.exports = __webpack_public_path__ + "media/wow.824fac8a.mp3";